<div class="flex flex-col w-full h-full bg-gray-100 p-4">
  <div class="bg-white rounded-lg shadow-md p-6 max-h-[calc(100vh-8rem)] overflow-y-auto">
    <h2 class="text-2xl font-bold text-gray-800 mb-6">Realização de Suprimento</h2>

    <div class="space-y-4">
      <div class="bg-gray-50 p-4 rounded-md">
        <div class="grid grid-cols-1 gap-4">
          <div>
            <label class="block text-sm font-medium text-gray-600 mb-1">Valor do Suprimento <span class="text-red-500">*</span></label>
            <p-inputNumber
              [(ngModel)]="amount"
              [min]="0.01"
              [max]="999999.99"
              mode="decimal"
              [minFractionDigits]="2"
              [maxFractionDigits]="2"
              currency="BRL"
              locale="pt-BR"
              class="w-full"
              [style]="{'width': '100%'}"
              inputId="supply-value">
            </p-inputNumber>
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-600 mb-1">Descrição / Observações</label>
            <textarea
              [(ngModel)]="description"
              pTextarea
              rows="3"
              class="w-full"
              placeholder="Digite observações sobre o suprimento (opcional)">
            </textarea>
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-600 mb-1">Espécie</label>
            <input
              [(ngModel)]="species"
              pInputText
              type="text"
              class="w-full"
              placeholder="Ex.: Dinheiro (opcional)">
          </div>
        </div>
      </div>
    </div>

    <!-- Botões de Ação -->
    <div class="flex justify-end space-x-4 mt-6">
      <button
        (click)="goBack()"
        [disabled]="loading"
        pButton
        type="button"
        label="ESC - Voltar"
        class="p-button-secondary">
      </button>
      <button
        (click)="performSupply()"
        [disabled]="amount <= 0 || loading"
        pButton
        type="button"
        [label]="loading ? 'Enviando...' : 'F1 - Realizar Suprimento'"
        class="p-button-success">
      </button>
    </div>
  </div>
</div>
